import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '星球漫画',
    url: 'https://www.xingqiumanhua.com',
    description: '星球漫画提供免费漫画全集在线免费阅读，下拉式阅读体验，海量免费漫画网站大全，免VIP看全集，好看的免费漫画推荐。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.xingqiumanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '星球漫画',
    url: 'https://www.xingqiumanhua.com',
    description: '免费漫画全集在线免费阅读平台',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@xingqiumanhua.com',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategorySection />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}